<div class="grid-y info-bar">
  <div class="cell info-div">
    <span> {{"eeoc-form.fostering-a-diverse" | translate}}</span>
  </div>
</div>
